import { render } from "./PopUpNewLink.vue?vue&type=template&id=f90af188"
import script from "./PopUpNewLink.vue?vue&type=script&lang=js"
export * from "./PopUpNewLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__